import "slick-carousel";
import {isRtl, toggleSliderNextButton, areAllSlidesVisible, isLastSlideVisibleRtl, isLastSlideVisibleLtr} from "../utils/helpers";

export default class SiyumTabs {

    constructor() {
        this.titlesContainer = document.querySelector('.siyum-reg__tabs__title .jet-listing-grid__items');
        this.titles = document.querySelectorAll('.siyum-reg__tabs__title .jet-listing-grid__items .jet-listing-grid__item');
        this.contents = document.querySelectorAll('.siyum-reg__tabs__content .jet-listing-grid__item');
        if (this.titles.length && this.contents.length) {
            this.init();
            this.initSlider();
            this.handleResize();
        }
    }

    init() {
        this.titles.forEach((title, index) => {
            title.addEventListener('click', () => this.activateTab(index));
        });

        if (this.titles.length > 0) {
            this.activateTab(0);
        }
    }

    activateTab(index) {
        this.deactivateAll();
        this.titles[index].classList.add('active');
        this.contents[index].style.display = 'block';
    }

    deactivateAll() {
        this.titles.forEach(title => title.classList.remove('active'));
        this.contents.forEach(content => content.style.display = 'none');
    }

    initSlider() {
        const $slider = $(this.titlesContainer);

        if (!$slider.hasClass('slick-initialized')) {
            $slider.slick({
                slidesToScroll: 1,
                slidesToShow: 1,
                infinite: false,
                arrows: true,
                mobileFirst: true,
                centerMode: true,
                rtl: isRtl(),
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            variableWidth: true,
                            centerMode: false,
                        }
                    }
                ]
            });

            setTimeout(() => {
                this.updateSliderNavigation($slider.slick('getSlick'));
            }, 100);
        }

        $slider.on('afterChange', (e, slick, currentSlide) => {
            this.handleAfterChange(slick, currentSlide);
        });

        $slider.on('init reInit', (e, slick) => {
            this.updateSliderNavigation(slick);
        });
    }

    handleAfterChange(slick, currentSlide) {
        if (window.innerWidth < 768) {
            this.activateTab(currentSlide);
        }

        this.updateSliderNavigation(slick);
    }

    updateSliderNavigation(slick) {
        const $slider = $(this.titlesContainer);
        const wraRect = $('.slick-list', $slider).get(0).getBoundingClientRect();
        const slideCount = slick.$slides.length;

        if (slideCount <= 1) {
            toggleSliderNextButton($slider, true);
            return;
        }

        if (slick.options.rtl) {
            const lastSlideRect = slick.$slides[slideCount - 1].getBoundingClientRect();
            toggleSliderNextButton($slider, isLastSlideVisibleRtl(lastSlideRect, wraRect));
        } else {
            const firstSlideRect = slick.$slides[0].getBoundingClientRect();
            const lastSlideRect = slick.$slides[slideCount - 1].getBoundingClientRect();

            if (areAllSlidesVisible(firstSlideRect, lastSlideRect, wraRect)) {
                toggleSliderNextButton($slider, true);
                return;
            }

            toggleSliderNextButton($slider, isLastSlideVisibleLtr(lastSlideRect, wraRect));
        }
    }

    handleResize() {
        window.addEventListener('resize', () => {
            const $slider = $(this.titlesContainer);
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('setPosition');
                this.updateSliderNavigation($slider.slick('getSlick'));
            }
        });
    }
}